import { render, staticRenderFns } from "./ResponseFail.vue?vue&type=template&id=56fef830"
import script from "./ResponseFail.vue?vue&type=script&lang=js"
export * from "./ResponseFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports